// App.js - Final version with correct flow
import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import Register from "./Register";
import Login from "./Login";
import AuthRouter from "./AuthRouter";

import DashboardClinic from "./DashboardClinic";
import DashboardPatient from "./DashboardPatient"; // (not used but kept if needed)
import Patienthome from "./PatientHome";           // (legacy, not used)
import ForgotPassword from "./ForgotPassword";
import ResetPasswordPage from "./ResetPasswordPage";
import DashboardDoctor from "./DashboardDoctor";
import RoleProtectedRoute from "./RoleProtectedRoute";

import DoctorProfileForm from "./DoctorProfileForm";
import DocttorProfileExpress from "./DoctorProfileSetupQuick";
import DoctorProfile from "./DoctorProfile";

import VerifyDoctor from "./VerifyDoctor";
import AdminVerificationPanel from "./AdminVerificationPanel";
import Home from "./LandingPage";
import AdminDashboard from "./AdminVerificationPanel";
import PatientProfileSetup from "./PatientProfileSetup";
import PatientProfileView from "./PatientProfileView";
import AppointmentView from "./pages/AppointmentView";
import ServiceWorkerNavigator from "./ServiceWorkerNavigator";
import ServiceMapper from "./AdnisServices";

import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import CookieConsent from "./components/CookieConsent";

import SearchDoctors from "./pages/SearchDoctors";
import MapDoctors from "./pages/MapDoctors";

import PatientShellDemo from "./pages/patient2/PatientShellDemo";
import Patient2Home from "./components/patient2/Patient2Home";
import PatientShell from "./pages/patient2/Patient2Container";

import PatientPortalHome from "./PatientPortalHub/PatientPortalHome";
import ExploreDoctors from "./PatientPortalHub/ExploreDoctors";
import PatientAppointments from "./PatientPortalHub/PatientAppointments";
import PatientDocuments from "./PatientPortalHub/PatientDocuments";
import PatientRecords from "./PatientPortalHub/PatientRecords";
import PatientMessages from "./PatientPortalHub/PatientMessages";
import PatientPrescriptions from "./PatientPortalHub/PatientPrescriptions";
import Explore from "./PatientPortalHub/PatientEducationHub";
import PatientMap from "./PatientPortalHub/PatientMap";
import AdminPromoDashboard from "./AdminPromoDashboard";
import Specialities from "./AdminSpecialtiesPage";
import ResearchDetail from "./ResearchDetail";
import LandingPagePracto from "./LandingPage";
import CitySpecLanding from "./CitySpecLanding";
import NotFound from "./pages/NotFound";
import DermatologyLanding from "./pages/specialities/DermatologyLandingPage";
import ClinicProfileSetup from "./pages/clinics/ClinicProfileSetup";


// or /sq/dermatologji if you prefer localized route

function ExploreDoctorsWrapper() {
  const navigate = useNavigate();

  return (
    <ExploreDoctors
      onDoctorClick={(id) => navigate(`/doctor/${id}`)}
      onOpenMap={() => navigate("/patient/map")}
    />
  );
}

function App() {
  return (
    <Router>
      <ServiceWorkerNavigator />

      <Routes>
        {/* Auth & public pages */}
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth" element={<AuthRouter />} />

        {/* Landing + generic public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        
        <Route path="/map" element={<MapDoctors />} />
        <Route path="/doctor/:id" element={<DoctorProfile />} />
        <Route path="/research/:doctorId/:researchId" element={<ResearchDetail />} />

        {/* ----------------- PATIENT AREA ----------------- */}
        {/* bare /patient → protected home */}
        <Route
          path="/patient"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientPortalHome />
            </RoleProtectedRoute>
          }
        />

 <Route
          path="/clinic-profile-setup"
          element={
            <RoleProtectedRoute allowedRole="clinic">
              <ClinicProfileSetup />
            </RoleProtectedRoute>
          }
        />
        

        {/* Main patient dashboards / home */}
        <Route
          path="/dashboard-patient"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientPortalHome />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient-home"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientPortalHome />
            </RoleProtectedRoute>
          }
        />

        {/* Patient shell v2 (if you actually use these) */}
        <Route
          path="/patient/v2"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientShell />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/v2/home"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <Patient2Home />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/v2/demo"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientShellDemo />
            </RoleProtectedRoute>
          }
        />

        {/* Patient hub sub-pages */}
        <Route
          path="/patient/explore"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <ExploreDoctorsWrapper />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/appointments"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientAppointments />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/documents"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientDocuments />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/records"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientRecords />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/messages"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientMessages />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/prescriptions"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientPrescriptions />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/posts"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <Explore />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/patient/map"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientMap />
            </RoleProtectedRoute>
          }
        />

        {/* Patient profile flow */}
        <Route path="/patient-setup" element={<PatientProfileSetup />} />
        <Route
          path="/patient-profile"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <PatientProfileView />
            </RoleProtectedRoute>
          }
        />

        {/* Patient view of a single appointment */}
        <Route
          path="/appointments/:appointmentId"
          element={
            <RoleProtectedRoute allowedRole="patient">
              <AppointmentView mode="patient" />
            </RoleProtectedRoute>
          }
        />

        {/* ----------------- DOCTOR AREA ----------------- */}
        <Route
          path="/dashboard-doctor"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <DashboardDoctor />
            </RoleProtectedRoute>
          }
        />

        {/* Doctor appointment deep-link */}
        <Route
          path="/doctor/appointments/:appointmentId"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <AppointmentView mode="doctor" />
            </RoleProtectedRoute>
          }
        />

        {/* Doctor profile setup */}
        <Route
          path="/doctor-profile-setup"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <DoctorProfileForm />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/doctor-profile-quick"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <DocttorProfileExpress />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/setup-doctor-profile"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <DoctorProfileForm />
            </RoleProtectedRoute>
          }
        />

        {/* Doctor verification */}
        <Route
          path="/verify-doctor"
          element={
            <RoleProtectedRoute allowedRole="doctor">
              <VerifyDoctor />
            </RoleProtectedRoute>
          }
        />

        {/* ----------------- CLINIC AREA ----------------- */}
        <Route
          path="/dashboard-clinic"
          element={
            <RoleProtectedRoute allowedRole="clinic">
              <DashboardClinic />
            </RoleProtectedRoute>
          }
        />

        {/* ----------------- ADMIN AREA ----------------- */}
        <Route
          path="/admin/verifications"
          element={
            <RoleProtectedRoute allowedRole="admin">
              <AdminVerificationPanel />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/admin-dashboard"
          element={
            <RoleProtectedRoute allowedRole="admin">
              <AdminDashboard />
            </RoleProtectedRoute>
          }
        />
        <Route path="/admin/promos" element={
          <RoleProtectedRoute allowedRole="admin">
            <AdminPromoDashboard />
            </RoleProtectedRoute>} />
        <Route
          path="/admin-servicemapper"
          element={
            <RoleProtectedRoute allowedRole="admin">
              <ServiceMapper />
            </RoleProtectedRoute>
          }
        />
         <Route
          path="/admin-specialities"
          element={
            <RoleProtectedRoute allowedRole="admin">
              <Specialities />
            </RoleProtectedRoute>
          }
        />
        
        {/* SEO routes */}
        <Route path="/:lang/:citySlug/:specSlug" element={<CitySpecLanding />} />
       <Route path="/:citySlug/:specSlug" element={<CitySpecLanding />} />

      {/* legacy */}
      <Route path="/search" element={<LandingPagePracto />} />
<Route path="/:lang/dermatology" element={<DermatologyLanding />} />

<Route path="*" element={<NotFound />} />

      </Routes>

      <CookieConsent />
    </Router>
  );
}

export default App;
